import { asArray, asOptionalString, asRecord, asString } from './common';

export interface TransportCompanyDto {
  id: string;
  name: string;
  nip?: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TransportCompanyOptionDto extends TransportCompanyDto {
  label: string;
  searchText: string;
}

export function normalizeTransportCompany(raw: unknown, entity = 'transportCompany'): TransportCompanyDto | null {
  const record = asRecord(raw);
  if (!record) return null;

  const id = asString(record.id, `${entity}.id`);
  const name = asString(record.name, `${entity}.name`);

  return {
    id,
    name,
    nip: asOptionalString(record.nip),
    contactPerson: asOptionalString(record.contactPerson),
    phone: asOptionalString(record.phone),
    email: asOptionalString(record.email),
    address: asOptionalString(record.address),
    notes: asOptionalString(record.notes),
    createdAt: asOptionalString(record.createdAt),
    updatedAt: asOptionalString(record.updatedAt),
  };
}

export function normalizeTransportCompanyOption(
  raw: unknown,
  entity = 'transportCompanyOption'
): TransportCompanyOptionDto {
  const company = normalizeTransportCompany(raw, entity) ?? { id: '', name: '' };
  const searchParts = [company.name, company.nip, company.contactPerson]
    .filter((part): part is string => Boolean(part && part.trim()));

  return {
    ...company,
    label: company.name,
    searchText: searchParts.join(' ').toLowerCase(),
  };
}

export function normalizeTransportCompanyOptions(
  raw: unknown,
  entity = 'transportCompanyOptions'
): TransportCompanyOptionDto[] {
  return asArray(raw, (item, index) => normalizeTransportCompanyOption(item, `${entity}[${index}]`));
}
